<template>
  <div class="p-d-flex p-ai-center" v-if="item">
    <div @click="toggleOrderStateOverlay($event, item.id)"
         class="state-badge pointer"
         :class="stateColor(item.state)">
      {{ stateLabel(item.state) }}
    </div>

    <div v-if="canChangeState">
      <a v-if="item.state === 0"
         :class="{
            'no-pointer': disabled,
            'billing-action-disabled': billingDataEditingLocked
          }"
         draggable="false"
         @click.prevent="changeOrderState(1)"
         v-tooltip.top="billingActionTooltipOptions(false, stateLabel(1))"
         href="#"
         class="p-link table-link-icon">
        <i class="pi pi-check-circle"/>
      </a>

      <a v-if="item.state === 1"
         :class="{
            'no-pointer': disabled,
            'billing-action-disabled': billingDataEditingLocked
          }"
         draggable="false"
         @click.prevent="changeOrderStateToWaitingOnClick"
         v-tooltip.top="billingActionTooltipOptions(false, stateLabel(3))"
         href="#"
         class="p-link table-link-icon">
        <i class="ti-arrow-circle-right"/>
      </a>

      <a v-else-if="item.state === 3"
         :class="{
            'no-pointer': disabled,
            'billing-action-disabled': billingDataEditingLocked
          }"
         draggable="false"
         @click.prevent="changeOrderState(5)"
         v-tooltip.top="billingActionTooltipOptions(false, stateLabel(5))"
         href="#"
         class="p-link table-link-icon">
        <i class="ti-arrow-circle-right"/>
      </a>

      <a v-else-if="item.state === 5"
         :class="{
            'no-pointer': disabled,
            'billing-action-disabled': billingDataEditingLocked
          }"
         draggable="false"
         @click.prevent="changeOrderState(7)"
         v-tooltip.top="billingActionTooltipOptions(false, stateLabel(7))"
         href="#"
         class="p-link table-link-icon">
        <i class="ti-arrow-circle-right"/>
      </a>

      <a v-else-if="item.state === 7"
         :class="{
            'no-pointer': disabled,
            'billing-action-disabled': billingDataEditingLocked
          }"
         draggable="false"
         @click.prevent="changeOrderState(8)"
         v-tooltip.top="billingActionTooltipOptions(false, stateLabel(8))"
         href="#"
         class="p-link table-link-icon">
        <i class="ti-arrow-circle-right"/>
      </a>
    </div>
  </div>

  <OverlayPanel :ref="'os-' + item.id" :breakpoints="{ '960px': '75vw' }" :autoZIndex="$store.state.firstLayerIsOpened">

<!--    <Spinner v-if="historyIsLoading"-->
<!--             :isSmall="true"-->
<!--             :spinnerStyle="'height:100px'"/>-->

    <table v-if="stateHistory.length">
      <tbody>
      <tr v-for="(data, index) of stateHistory" :key="index">
        <td class="state-badge-td" :class="{ 'state-badge-td--last': index === stateHistory.length - 1 }">
          <div class="state-badge"
               :class="isValidState(data.new) ? stateColor(data.new) : ''"
               style="width: auto;">
            {{ isValidState(data.new) ? stateLabel(data.new) : '-' }}
          </div>
        </td>

        <td class="state-created-by-td" :class="{ 'state-created-by-td--last': index === stateHistory.length - 1 }">
          {{ formatBy(data.created_at, data.creator) }}
        </td>
      </tr>
      </tbody>
    </table>

    <div v-else-if="stateHistoryLoaded">{{ $t('No data available') }}</div>
  </OverlayPanel>
</template>


<script>
import OrderStates from '@/translations/states/OrderStates'
import httpClient from "@/services/http.services";
import formatMixins from "@/mixins/formatMixins";
import settings from "@/settings";
import constants from "@/constants";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  // settings,
  mixins: [ showErrorsMixins, formatMixins, billingRestrictionsMixin ],
  // components: { OverflowOverlayPanel },
  emits: ['change-state', 'change-order-state-to-waiting-on-click'],
  name: 'OrderStateButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    item: Object,
    canChangeState: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isLoading: false,
      historyIsLoading: false,
      stateHistory: [],
      stateHistoryLoaded: false,
      historyRequestId: 0,
      constants,
      OrderStates
    }
  },
  methods: {
    isValidState(value) {
      return value || value === 0
    },

    orderState(num) {
      return this.OrderStates.find(state => Number(state.num) === Number(num)) || null
    },

    stateLabel(num) {
      const state = this.orderState(num)

      return state?.label?.[this.$i18n.locale] || state?.label?.en || ''
    },

    stateColor(num) {
      return this.orderState(num)?.color || ''
    },
    changeOrderStateToWaitingOnClick() {
      if (this.disabled || this.billingActionIsRestricted()) return
      const obj = {
        id: this.item.id,
        staffComment: this.item.staff_comment
      }
      this.$emit('change-order-state-to-waiting-on-click', obj)
    },
    async changeOrderState(newState, changeStaffComment = false, staffComment) {
      if (this.disabled || this.billingActionIsRestricted() || this.isLoading || !this.item) {
        return
      }

      const order = this.item
      const oldState = this.item.state
      order.state = newState
      this.isLoading = true

      try {
        const { status, data } = await httpClient.post('order/change-state', {orderId: order.id, state: newState, changeStaffComment, staffComment})
        if (status === 200 && data?.success) {
          if (changeStaffComment) {
            order.staff_comment = staffComment ?? null
          }

          this.resetStateHistory(false)
          this.$emit('change-state', order.id)
        } else if (data?.error) {
          order.state = oldState
          console.log(data.error)
          this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
        }
      } catch(err) {
        order.state = oldState
        this.showError(err)
      } finally {
        this.isLoading = false
      }
    },
    async toggleOrderStateOverlay(event, id) {
      if (!event || !id || this.historyIsLoading) return false

      const overlay = this.$refs['os-' + id]

      if (this.stateHistoryLoaded) {
        overlay?.toggle?.(event)
        return
      }

      const target = event.currentTarget

      await this.loadStateHistory()

      if (!this.stateHistoryLoaded) return

      await this.$nextTick()
      overlay?.toggle?.(event, target)
    },
    async loadStateHistory() {
      const requestId = ++this.historyRequestId
      this.historyIsLoading = true

      try {
        const { status, data } = await httpClient.post('order/get-state-history', { id: this.item.id })

        if (requestId !== this.historyRequestId) return

        if (status === 200 && data?.success && Array.isArray(data.history)) {
          this.stateHistory = data.history
          this.stateHistoryLoaded = true
          return
        }

        this.showUnknownError()
      } catch (error) {
        if (requestId !== this.historyRequestId) return
        this.showError(error)
      } finally {
        if (requestId === this.historyRequestId) {
          this.historyIsLoading = false
        }
      }
    },
    resetStateHistory(hideOverlay = true) {
      this.historyRequestId += 1
      this.historyIsLoading = false
      this.stateHistory = []
      this.stateHistoryLoaded = false

      if (hideOverlay) {
        this.hideOrderStateOverlay()
      }
    },
    hideOrderStateOverlay() {
      if (!this.item?.id) return
      this.$refs['os-' + this.item.id]?.hide?.()
    },
  },
  watch: {
    'item.id'() {
      this.resetStateHistory()
    },
    'item.state'() {
      if (this.stateHistoryLoaded) {
        this.resetStateHistory()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.state-badge-td {
  padding: 0 10px 10px 0;
}
.state-badge-td--last {
  padding: 0 10px 0 0;
}
.state-created-by-td {
  max-width: 500px;
  padding: 0 10px 10px 5px;
}
.state-created-by-td--last {
  padding: 0 10px 0 5px;
}

.billing-action-disabled {
  cursor: not-allowed !important;
  opacity: 0.55;
}
</style>
